import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { toast } from "sonner";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "", phone: "" });
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error("كلمة المرور غير متطابقة"); return; }
    if (form.password.length < 6) { toast.error("6 أحرف على الأقل"); return; }
    if (!agreed) { toast.error("يجب الموافقة على الشروط والأحكام وسياسة الخصوصية"); return; }
    setLoading(true);
    try { await register({ name: form.name, email: form.email, password: form.password, phone: form.phone, terms_accepted: true }); toast.success("تم إنشاء الحساب 🎉"); nav("/"); }
    catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-14">
      <div className="text-center mb-8">
        <img src={LOGO_URL} alt="FLUORIT" className="mx-auto h-16 w-16 object-contain" />
        <h1 className="text-2xl font-extrabold text-emerald-950 mt-3">{t.auth.registerTitle}</h1>
      </div>
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <div><Label>{t.auth.name}</Label><Input data-testid="reg-name" required value={form.name} onChange={upd("name")} /></div>
        <div><Label>{t.auth.email}</Label><Input data-testid="reg-email" type="email" required value={form.email} onChange={upd("email")} /></div>
        <div><Label>{t.auth.phone}</Label><Input data-testid="reg-phone" value={form.phone} onChange={upd("phone")} /></div>
        <div><Label>{t.auth.password}</Label><Input data-testid="reg-password" type="password" required value={form.password} onChange={upd("password")} /></div>
        <div><Label>{t.auth.confirm}</Label><Input data-testid="reg-confirm" type="password" required value={form.confirm} onChange={upd("confirm")} /></div>
        <label className="flex items-start gap-3 text-sm text-slate-700 bg-amber-50 border border-amber-200 rounded-xl p-3 cursor-pointer">
          <input data-testid="reg-terms" type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-1 w-4 h-4 accent-emerald-900" />
          <span>
            أوافق على <Link to="/terms" target="_blank" className="text-emerald-900 font-semibold hover:text-amber-700">شروط الاستخدام</Link>
            و<Link to="/disclaimer" target="_blank" className="text-emerald-900 font-semibold hover:text-amber-700">إخلاء المسؤولية</Link>
            و<Link to="/privacy" target="_blank" className="text-emerald-900 font-semibold hover:text-amber-700">سياسة الخصوصية</Link>
            الخاصة بمنصة فلوريت.
          </span>
        </label>
        <Button data-testid="reg-submit" disabled={loading} className="w-full h-11 bg-emerald-950 hover:bg-emerald-900">{loading ? "…" : t.auth.registerBtn}</Button>
        <div className="text-sm text-center text-slate-600">
          {t.auth.switchToLog} <Link to="/login" className="text-emerald-900 font-semibold">{t.nav.login}</Link>
        </div>
      </form>
    </div>
  );
}
